import { useState } from "react";
import { enviarSmsService } from "../../../services/enviarSmsService";
import { verificarSmsService } from "../../../services/verificarSmsService";
import { SMS } from "../Interface/Sms";

// --------------------- Import Services ---------------------
export const useSms = () => {
  const [isLoading, setIsLoading] = useState(true);

  const enviaSms = async (data: Partial<SMS>): Promise<boolean> => {
    const dataSms = {
      celular: data.celular,
    };
    setIsLoading(true);

    try {
      const response = await enviarSmsService(dataSms);
      return !!response;
    } catch (error: any) {
      // Tenta extrair a mensagem de erro do backend
      const message =
        error?.response?.data?.message || // NestJS ou mensagens estruturadas
        error?.response?.data?.error || // Outros padrões
        error?.message || // Erro genérico
        "Erro ao enviar SMS.";

      console.error("Erro ao enviar:", message);

      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const verificaSms = async (dataVerifica: SMS) => {
    setIsLoading(true);
    try {
      const { success } = await verificarSmsService(dataVerifica);
      return success === true;
    } catch (error) {
      console.error("Erro ao verificar:", error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { enviaSms, verificaSms, isLoading };
};
